import { FileTypeEnum } from "../enums/fileType.enum";

export function getImgSrc(fileType: FileTypeEnum): string {
    switch (fileType) {
        case FileTypeEnum.Pdf: return 'assets/images/file-note.svg';
        case FileTypeEnum.Image: return 'assets/images/image.svg';
        default: return 'assets/images/file-note.svg'
    }
}